import { ICategoryDetails } from '@/models/categories.model';

export const normalizeCategoryLocale = (category: ICategoryDetails) => ({
  ...category,
  locale: [...category.locale].sort((a, b) => b.locale.localeCompare(a.locale)),
  is_restoration: category.is_restoration ?? false,
  is_heavy: category.is_heavy === true ? true : null,
});
